import { Question } from "../interfaces/question.interface";
import { DurationOption } from "../features/session/forms/TimedPitchSessionForm";
import { INTERVIEW_TYPES } from "../pages/NewSession";

export interface Option {
    value: string;
    label: string;
}

// Options for selects
export const sessionTypeOptions: Option[] = [
    { value: 'general', label: 'General (balanced)' },
    { value: 'technical', label: 'Technical Interview' },
    { value: 'behavioral', label: 'Behavioral Interview' },
    { value: 'caseStudy', label: 'Case Study' },
];

export const jobRoleOptions: Option[] = [
    { value: 'softwareEngineer', label: 'Software Engineer' },
    { value: 'productManager', label: 'Product Manager' },
    { value: 'dataScientist', label: 'Data Scientist' },
    { value: 'dataAnalyst', label: 'Data Analyst' },
    { value: 'projectManager', label: 'Project Manager' },
    { value: 'businessAnalyst', label: 'Business Analyst' },
    { value: 'marketingSpecialist', label: 'Marketing Specialist' },
    { value: 'salesRepresentative', label: 'Sales Representative' },
    { value: 'customerServiceRepresentative', label: 'Customer Service Representative' },
    { value: 'humanResourcesSpecialist', label: 'Human Resources Specialist' },
    { value: 'financialAnalyst', label: 'Financial Analyst' },
    { value: 'graphicDesigner', label: 'Graphic Designer' },
    { value: 'uxDesigner', label: 'UX/UI Designer' },
    { value: 'mechanicalEngineer', label: 'Mechanical Engineer' },
    { value: 'electricalEngineer', label: 'Electrical Engineer' },
    { value: 'civilEngineer', label: 'Civil Engineer' },
    { value: 'teacher', label: 'Teacher' },
    { value: 'nurse', label: 'Nurse' },
    { value: 'doctor', label: 'Doctor' },
    { value: 'lawyer', label: 'Lawyer' },
    { value: 'accountant', label: 'Accountant' },
    { value: 'consultant', label: 'Consultant' },
    { value: 'operationsManager', label: 'Operations Manager' },
    { value: 'administrativeAssistant', label: 'Administrative Assistant' },
    { value: 'webDeveloper', label: 'Web Developer' },
    { value: 'digitalMarketer', label: 'Digital Marketer' },
    { value: 'contentWriter', label: 'Content Writer' },
    { value: 'socialMediaManager', label: 'Social Media Manager' },
    { value: 'qaEngineer', label: 'Quality Assurance Engineer' },
    { value: 'devOpsEngineer', label: 'DevOps Engineer' },
    { value: 'networkEngineer', label: 'Network Engineer' },
    { value: 'systemsAdministrator', label: 'Systems Administrator' },
    { value: 'cybersecuritySpecialist', label: 'Cybersecurity Specialist' },
    { value: 'machineLearningEngineer', label: 'Machine Learning Engineer' },
    { value: 'aiResearcher', label: 'AI Researcher' },
    { value: 'blockchainDeveloper', label: 'Blockchain Developer' },
    { value: 'supplyChainManager', label: 'Supply Chain Manager' },
    { value: 'pharmacist', label: 'Pharmacist' },
    { value: 'dentist', label: 'Dentist' },
    { value: 'architect', label: 'Architect' },
    { value: 'therapist', label: 'Therapist' },
    // ... any other major job roles
];

export const difficultyOptions: Option[] = [
    { value: 'easy', label: 'Easy' },
    { value: 'medium', label: 'Medium' },
    { value: 'hard', label: 'Hard' },
];

export const durationOptions: Option[] = [
    { value: '15', label: '15 Minutes' },
    { value: '30', label: '30 Minutes' },
    { value: '60', label: '60 Minutes' },
];

export const sessionCount: Option[] = [
    { value: '1', label: '1 session' },
    { value: '2', label: '2 sessions' },
    { value: '3', label: '3 sessions' },
];

// Mapping from job roles to topic options
export const topicOptionsByJobRole: { [key: string]: Option[] } = {
    softwareEngineer: [
        { value: 'algorithms', label: 'Algorithms' },
        { value: 'dataStructures', label: 'Data Structures' },
        { value: 'systemDesign', label: 'System Design' },
        { value: 'codingPractices', label: 'Coding Practices' },
        { value: 'testing', label: 'Testing' },
    ],
    productManager: [
        { value: 'productStrategy', label: 'Product Strategy' },
        { value: 'roadmapping', label: 'Roadmapping' },
        { value: 'userResearch', label: 'User Research' },
        { value: 'marketAnalysis', label: 'Market Analysis' },
        { value: 'stakeholderManagement', label: 'Stakeholder Management' },
    ],
    dataScientist: [
        { value: 'machineLearning', label: 'Machine Learning' },
        { value: 'statistics', label: 'Statistics' },
        { value: 'dataAnalysis', label: 'Data Analysis' },
        { value: 'programming', label: 'Programming' },
        { value: 'dataVisualization', label: 'Data Visualization' },
    ],
};

export interface FormInputs {
    id?: string;
    sessionType: Option | null;
    jobRole: Option | null;
    title: string;
    difficulty: Option | null;
    duration: DurationOption | Option | null;
    topics: Option[] | null;
    completed?: boolean;
    generatedQuestion?: boolean;
    generatingQuestion?: boolean;
    status: 'Completed' | 'In Progress';
    createdAt?: string;
    score?: number;
    questions?: Question[];
    currentQuestion?: number;
    timeRemaining?: number;
    overallScore: number;
    runCount: number;
    notes: string;
    interviewType: INTERVIEW_TYPES;
    task?: string;
    interviewer?: {
        id: string;
        name: string;
        title: string;
        image: string;
        voiceId: string;
    };
    selectedInterviewerId?: string;
}